import React from 'react';
import PropTypes from 'prop-types';
import { Link, ButtonGroup, PrimaryButton } from '@common/components';
import { ViewSubmissionDrawerButton } from './view-submission-drawer-button';
import { buildDialogUrl } from '@common/services';

export function OnHoldCtaButton({ application }) {
  const reviewStates = ['submitted', 'in_review'];
  if (reviewStates.includes(application.state)) {
    return <ViewSubmissionDrawerButton applicationId={application.id} />;
  }

  if (application.state === 'offer' && application.activeOffer) {
    const offerConfirmationDrawerUrl = buildDialogUrl(
      'offer-confirmation-drawer',
      { props: { offerId: application?.activeOffer?.id || '' } }
    );

    return (
      <ButtonGroup>
        <Link to={offerConfirmationDrawerUrl}>
          <PrimaryButton>Offer</PrimaryButton>
        </Link>
        <ViewSubmissionDrawerButton applicationId={application.id} />
      </ButtonGroup>
    );
  }

  if (application.state === 'accepted') {
    const assignmentId = application.acceptedOffer.staffingRequestAssignment.id;
    return (
      <ButtonGroup>
        <Link to={`/works/supplier/team/${assignmentId}`}>
          <PrimaryButton>Assignment</PrimaryButton>
        </Link>
        <ViewSubmissionDrawerButton applicationId={application.id} />
      </ButtonGroup>
    );
  }

  return null;
}

OnHoldCtaButton.propTypes = {
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    canWithdraw: PropTypes.object,
    activeOffer: PropTypes.object,
    acceptedOffer: PropTypes.shape({
      staffingRequestAssignment: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
  worksProfile: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  staffingRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
